import React from "react";
import * as DATA from "../utils/Data";
import Card from "./Card";
import "./ReportList.css";

export default ({ reportItems }) => {
  return reportItems.length ? (
    <div className="report-list">
      {reportItems.map(({ titulo, url, imagen }, i) => (
        <Card key={i}>
          <a
            className="card-item report-item"
            href={url}
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="l-report-col1">
              <img
                className="report-item__img"
                src={DATA.SERVER_URL + imagen.data.url}
                alt=""
              />
            </div>
            <div className="l-report-col2">
              <h4 className="report-item__title">{titulo}</h4>
              <div className="btn report-item__btn">Abrir pdf</div>
            </div>
          </a>
        </Card>
      ))}
    </div>
  ) : (
    <div className="fact-list">No data</div>
  );
};



// WEBPACK FOOTER //
// ./src/components/ReportList.js